import {
  DownOutlined,
  DownloadOutlined,
  EditOutlined,
  EyeOutlined,
  FileExcelOutlined,
  SearchOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
  BellOutlined,
  ExclamationCircleOutlined,
  CheckCircleTwoTone,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import Buttons from "../../components/Button/Button";
import Tabs from "../../components/AntdTabs/AntdTabs";
import { CardContainer, GroupCardContainer } from "../../components/Card/CardContainer";
import PageTitleNested from "../../components/PageTitle/PageTitleNested";
import Text from "../../components/Text/Text";
import {
  Avatar,
  Card,
  Col,
  Divider,
  Form,
  Image,
  Modal,
  Row,
  Table,
  Tooltip,
  Spin,
  Button,
  Switch,
  Upload,
  Checkbox,
  message,
} from "antd";
import { FlexCol, FlexRow } from "../../components/Container/Container";
import TextArea from "../../components/Input/TextArea";
import styled from "styled-components";
import color from "../../resource/color";
import Tag from "../../components/Tag/Tag";
import {
  getExcelOrderProReport,
  getPromotionById,
  getPromotionLog,
  getPromotionOrderDetailReport,
  getPromotionQuotaHistory,
  getReportExcel,
  updatePromotion,
  updatePromotionFile,
  updatePromotionImage,
} from "../../datasource/PromotionDatasource";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import promotionState from "../../store/promotion";
import Descriptions from "../../components/Description/Descriptions";
import TableContainer from "../../components/Table/TableContainer";
import {
  PROMOTION_TYPE_NAME,
  PromotionGroup,
  PromotionGroupOption,
  PromotionType,
} from "../../definitions/promotion";
import { AlignType } from "rc-table/lib/interface";
import moment from "moment";
require("moment/locale/th");
import { dateFormatter, numberFormatter, priceFormatter } from "../../utility/Formatter";
import { ProductName } from "../Shared/AddProduct";
import { ProductEntity } from "../../entities/PoductEntity";
import {
  PromotionConditionEntity,
  PromotionConditionGroupEntity,
  PromotionSettingHistory,
  PromotionShopEntity,
} from "../../entities/PromotionSettingEntity";
import image from "../../resource/image";
import Input from "../../components/Input/Input";
import { CollapsePanelHeader } from "./createPromotionStep/PromotionCreateStep3";
import { useForm } from "antd/lib/form/Form";
import { BASE_URL } from "../../config/develop-config";
import axios, { AxiosRequestConfig } from "axios";
import Permission, { checkPermission } from "../../components/Permission/Permission";
import { getQuotaString, getQuotaUnit } from "../../utility/promotionUtility";
import { formatFileSize } from "../../utility/formatFileSize";
import icon from "../../resource/icon";
import Select from "../../components/Select/Select";
import dayjs, { Dayjs } from "dayjs";
import { zoneDatasource } from "../../datasource/ZoneDatasource";
import Collapse from "../../components/Collapse/collapse";
import ImgCrop from "../../components/ImgCrop/ImgCrop";
import { ImageWithDeleteButton } from "../../components/Image/Image";
import DatePicker, { TimePicker, RangePicker } from "../../components/DatePicker/DatePicker";
import { RcFile } from "antd/es/upload";
import { roleAtom } from "../../store/RoleAtom";
import { useNotificationContext } from "../../context/NotificationProvider";

const MemoArea = styled.div`
  width: 100%;
  background: ${color.background1};
  border: 1px solid ${color.background2};
  border-radius: 8px;

  display: flex;
  align-items: center;
  padding: 16px;
`;
const UploadHorizontal = styled(Upload)`
  .ant-upload,
  .ant-upload-list-picture-card-container,
  .ant-upload-picture-card-wrapper,
  .ant-upload-list-picture-card .ant-upload-list-item {
    height: 130px;
    width: 220px;
  }
`;
const UploadArea = styled.div`
  background: ${color.background1};
  border: 1px dashed;
  border-radius: 6px;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
`;
const UploadIcon = (
  <>
    <svg width='65' height='65' viewBox='0 0 65 65' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle opacity='0.36' cx='32.3335' cy='32.0176' r='32' fill='#E5EAEE' />
      <path
        d='M41.6667 29.3512C41.313 29.3512 40.9739 29.4917 40.7239 29.7418C40.4738 29.9918 40.3333 30.3309 40.3333 30.6846V35.1912L38.36 33.2179C37.6632 32.5266 36.7215 32.1387 35.74 32.1387C34.7585 32.1387 33.8168 32.5266 33.12 33.2179L32.1867 34.1646L28.88 30.8446C28.1832 30.1533 27.2415 29.7654 26.26 29.7654C25.2785 29.7654 24.3368 30.1533 23.64 30.8446L21.6667 32.8312V25.3512C21.6667 24.9976 21.8071 24.6585 22.0572 24.4084C22.3072 24.1584 22.6464 24.0179 23 24.0179H33.6667C34.0203 24.0179 34.3594 23.8774 34.6095 23.6274C34.8595 23.3773 35 23.0382 35 22.6846C35 22.3309 34.8595 21.9918 34.6095 21.7418C34.3594 21.4917 34.0203 21.3512 33.6667 21.3512H23C21.9391 21.3512 20.9217 21.7727 20.1716 22.5228C19.4214 23.273 19 24.2904 19 25.3512V41.6446C19.0035 42.6266 19.3952 43.5673 20.0895 44.2617C20.7839 44.9561 21.7247 45.3477 22.7067 45.3512H39.2933C39.6546 45.3484 40.0137 45.2945 40.36 45.1912V45.1912C41.1299 44.9753 41.8077 44.5127 42.2894 43.8744C42.7711 43.2362 43.0301 42.4575 43.0267 41.6579V30.6846C43.0267 30.5072 42.9914 30.3316 42.9227 30.1681C42.854 30.0046 42.7534 29.8564 42.6268 29.7322C42.5001 29.608 42.35 29.5104 42.1851 29.445C42.0202 29.3796 41.844 29.3477 41.6667 29.3512ZM23 42.6846C22.6464 42.6846 22.3072 42.5441 22.0572 42.294C21.8071 42.044 21.6667 41.7049 21.6667 41.3512V36.5912L25.52 32.7379C25.7149 32.5441 25.9785 32.4353 26.2533 32.4353C26.5282 32.4353 26.7918 32.5441 26.9867 32.7379L36.9467 42.6846H23ZM40.3333 41.3512C40.3248 41.6094 40.2414 41.8596 40.0933 42.0712L34.0667 36.0179L35.0133 35.0846C35.1089 34.987 35.223 34.9095 35.3489 34.8566C35.4749 34.8037 35.6101 34.7764 35.7467 34.7764C35.8833 34.7764 36.0185 34.8037 36.1444 34.8566C36.2703 34.9095 36.3844 34.987 36.48 35.0846L40.3333 38.9646V41.3512ZM44.3333 21.3512H43V20.0179C43 19.6643 42.8595 19.3251 42.6095 19.0751C42.3594 18.825 42.0203 18.6846 41.6667 18.6846C41.313 18.6846 40.9739 18.825 40.7239 19.0751C40.4738 19.3251 40.3333 19.6643 40.3333 20.0179V21.3512H39C38.6464 21.3512 38.3072 21.4917 38.0572 21.7418C37.8071 21.9918 37.6667 22.3309 37.6667 22.6846C37.6667 23.0382 37.8071 23.3773 38.0572 23.6274C38.3072 23.8774 38.6464 24.0179 39 24.0179H40.3333V25.3512C40.3333 25.7049 40.4738 26.044 40.7239 26.294C40.9739 26.5441 41.313 26.6846 41.6667 26.6846C42.0203 26.6846 42.3594 26.5441 42.6095 26.294C42.8595 26.044 43 25.7049 43 25.3512V24.0179H44.3333C44.687 24.0179 45.0261 23.8774 45.2761 23.6274C45.5262 23.3773 45.6667 23.0382 45.6667 22.6846C45.6667 22.3309 45.5262 21.9918 45.2761 21.7418C45.0261 21.4917 44.687 21.3512 44.3333 21.3512V21.3512Z'
        fill='#6B7995'
      />
    </svg>
  </>
);
const imgCropProps = {
  modalTitle: "ปรับขนาดรูปภาพ",
  modalOk: "ยืนยัน",
  modalCancel: "ยกเลิก",
};

const getBase64 = (img: RcFile, callback: (url: string) => void) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result as string));
  reader.readAsDataURL(img);
};
function base64SizeInBytes(base64: string): number {
  const base64Data = base64.split(",")[1]; // remove header
  return Math.ceil((base64Data.length * 3) / 4);
}

function bytesToMB(bytes: number): number {
  return bytes / (1024 * 1024);
}
export async function resizeBase64Image(
  base64: string,
  maxSizeMB = 2,
  maxWidth = 1920,
  maxHeight = 1920,
): Promise<string> {
  return new Promise((resolve) => {
    const img = document.createElement("img");
    img.src = base64;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d")!;

      let { width, height } = img;

      // ✅ Resize dimensions (keep ratio)
      if (width > maxWidth || height > maxHeight) {
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        width *= ratio;
        height *= ratio;
      }

      canvas.width = width;
      canvas.height = height;

      ctx.drawImage(img, 0, 0, width, height);

      let quality = 0.9;
      let output = canvas.toDataURL("image/jpeg", quality);

      // ✅ Reduce quality until < max size
      while (bytesToMB(base64SizeInBytes(output)) > maxSizeMB && quality > 0.1) {
        quality -= 0.1;
        output = canvas.toDataURL("image/jpeg", quality);
      }

      resolve(output);
    };
  });
}

export interface NotiApp {
  imagePromotion: string;
  promotionSubject: string;
  promotionDetail: string;
  isShowShopApp: boolean;
  isShowSaleApp: boolean;
}

export const PromotionDetail: React.FC = () => {
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const navigate = useNavigate();
  const promoStateValue = useRecoilValue(promotionState);
  const [isInvalid, setIsInvalid] = useState<boolean>(
    moment(promoStateValue.promotion?.endDate).isBefore(moment()),
  );
  const [promotion, setPromotion] = useState<any>();
  const [keyTab, setKeyTab] = useState<string>("1");

  const fetchPromotion = async () => {
    const id = pathSplit[4];
    await getPromotionById(id)
      .then(async (res) => {
        setIsInvalid(moment(res.endDate).isBefore(moment()));
        setPromotion(res);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    fetchPromotion();
  }, [keyTab]);

  const PageTitle = () => {
    return (
      <PageTitleNested
        title={"รายละเอียดโปรโมชัน"}
        cutParams
        onBack={() => navigate(-1)}
        customBreadCrumb={
          <BreadCrumb
            data={[
              { text: "รายการโปรโมชัน", path: -1 },
              {
                text: "รายละเอียดโปรโมชัน",
                path: window.location.pathname,
              },
            ]}
          />
        }
        extra={
          !isInvalid && (
            <Buttons
              title='แก้ไขโปรโมชัน'
              icon={<EditOutlined />}
              onClick={() => navigate(`/PromotionPage/promotion/edit/${pathSplit[4]}`)}
            />
          )
        }
      />
    );
  };

  const tabsItems = [
    {
      key: "1",
      label: "รายละเอียดโปรโมชัน",
      children: <DetailTab data={promotion} />,
    },
    {
      key: "2",
      label: "รายละเอียดการแสดงผล",
      children: <DetailApp data={promotion} onUpdate={fetchPromotion} />,
    },
    {
      key: "4",
      label: "รายการคำสั่งซื้อ",
      children: <DetailOrderTab />,
    },
    {
      key: "3",
      label: "ประวัติการสร้างโปรโมชัน",
      children: <HistoryTab />,
    },
  ];

  return (
    <>
      <CardContainer>
        <PageTitle />
        <br />
        <Tabs
          data={tabsItems}
          defaultTab={keyTab}
          onChange={(key) => {
            setKeyTab(key);
            fetchPromotion();
          }}
        />
      </CardContainer>
    </>
  );
};

interface DetailTabProps {
  data: any;
  onUpdate?: () => Promise<void>;
}

export const DetailTab: React.FC<DetailTabProps> = ({ data }) => {
  const navigate = useNavigate();
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const { company } = userProfile;
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const roleData = useRecoilValue(roleAtom);
  const isExcel = checkPermission(["promotion", "excel"], roleData);

  const promotion = data;
  const [showPromotion, setShowPromotion] = useState(true);
  const [loadingProduct, setLoadingProduct] = useState(false);
  const items: PromotionConditionGroupEntity[] = data?.conditionDetail || [];
  const [form] = useForm();
  const [showQuotaHistory, setShowQuotaHistory] = useState<PromotionShopEntity>();
  const [quotaHistory, setQuotaHistory] = useState<any>({});

  const { startUploadProcess } = useNotificationContext();
  const [progressValue, setProgressValue] = useState(0);

  const fetchQuotaHistory = async (customerCompanyId: number) => {
    const promotionId = pathSplit[4];
    await getPromotionQuotaHistory(promotionId, customerCompanyId).then((res) => {
      const newQuotaHistory = { ...quotaHistory };
      newQuotaHistory[customerCompanyId] = res;
      setQuotaHistory(newQuotaHistory);
    });
  };

  const columns = [
    {
      title: "รหัสร้านค้า",
      dataIndex: "customerNo",
      align: "center" as AlignType,
      render: (text: string) => <a>{text}</a>,
    },
    {
      title: "ชื่อร้านค้า",
      dataIndex: "customerName",
      align: "center" as AlignType,
      render: (text: string) => <a>{text}</a>,
    },
    {
      title: "เขตการขาย",
      dataIndex: "zone",
      align: "center" as AlignType,
    },
    {
      title: `โควตาที่ได้รับ (${
        promotion?.promotionType ? getQuotaUnit(promotion?.promotionType) : ""
      })`,
      dataIndex: "quotaReceive",
      align: "center" as AlignType,
      render: (value) => priceFormatter(value, 2, true, true),
      hidden: !promotion?.isQuotaShop,
    },
    {
      title: `โควตาที่ใช้ (${
        promotion?.promotionType ? getQuotaUnit(promotion?.promotionType) : ""
      })`,
      dataIndex: "quotaUsed",
      align: "center" as AlignType,
      render: (value, customer) => {
        const history = quotaHistory[customer.customerCompanyId];
        return (
          <>
            <span>
              {priceFormatter(value, 2, true, true)}&nbsp;
              <img
                src={icon.popup}
                style={{
                  width: 16,
                  height: 16,
                  cursor: "pointer",
                }}
                onClick={() => {
                  setShowQuotaHistory(customer);
                  if (!history) {
                    fetchQuotaHistory(customer.customerCompanyId);
                  }
                }}
              />
            </span>
            <Modal
              open={showQuotaHistory && showQuotaHistory.customerNo === customer.customerNo}
              onCancel={() => setShowQuotaHistory(undefined)}
              width={900}
              footer={null}
            >
              <Text level={5} fontWeight={700}>
                รายการคำสั่งซื้อที่ใช้โควตา
              </Text>
              <br />
              <Row>
                <Col span={12}>
                  <Descriptions label='ชื่อร้านค้า' value={customer.customerName} />
                </Col>
                <Col span={12}>
                  <Descriptions label='เขตการขาย' value={customer.zone} />
                </Col>
                <Col span={12}>
                  <Descriptions label='คำสั่งซื้อทั้งหมด' value={history ? history.length : 0} />
                </Col>
                <Col span={12}>
                  <Descriptions
                    label='โควตาที่ใช้ทั้งหมด'
                    value={
                      history
                        ? numberFormatter(history.reduce((acc, val) => acc + val?.quotaUsed, 0))
                        : 0
                    }
                  />
                </Col>
              </Row>
              <TableContainer>
                <Table
                  columns={[
                    {
                      title: "วันที่สร้าง",
                      dataIndex: "createAt",
                      align: "center" as AlignType,
                      render: (val) => dateFormatter(val),
                    },
                    {
                      title: "รหัสคำสั่งซื้อ",
                      dataIndex: "orderId",
                      align: "center" as AlignType,
                      render: (val, row: any) => (
                        <span>
                          {row.orderNo}
                          <img
                            src={icon.ArrowUpRight}
                            style={{
                              width: 16,
                              height: 16,
                              cursor: "pointer",
                            }}
                            onClick={() => navigate(`/order/` + row.orderId)}
                          />
                        </span>
                      ),
                    },
                    {
                      title: `โควตาที่ใช้ (${
                        promotion?.promotionType ? getQuotaUnit(promotion?.promotionType) : ""
                      })`,
                      dataIndex: "quotaUsed",
                      align: "center" as AlignType,
                      render: (val) => priceFormatter(val, 2, true, true),
                    },
                  ]}
                  dataSource={history}
                />
              </TableContainer>
            </Modal>
          </>
        );
      },
      hidden: !promotion?.isQuotaShop,
    },
    {
      title: `โควตาที่เหลือ (${
        promotion?.promotionType ? getQuotaUnit(promotion?.promotionType) : ""
      })`,
      dataIndex: "quotaBalance",
      align: "center" as AlignType,
      render: (value) => priceFormatter(value, 2, true, true),
      hidden: !promotion?.isQuotaShop,
    },
  ];

  const ToggleButton = ({ title, isSelected }: { title: string; isSelected: boolean }) => {
    return (
      <Buttons
        title={title}
        typeButton={isSelected ? "primary" : "primary-light"}
        style={{
          width: 168,
        }}
        onClick={!isSelected ? () => setShowPromotion(!showPromotion) : undefined}
      />
    );
  };

  const DetailRow = ({ content }: { content: string }) => {
    return (
      <Row justify='end' style={{ padding: "0 12px 16px" }}>
        <Text level={5} color='primary'>
          {content}
        </Text>
      </Row>
    );
  };

  const onDownloadExcel = async () => {
    const headers = { "Content-Type": "blob" };
    const config: AxiosRequestConfig = {
      method: "POST",
      url: `${BASE_URL}/master/report/report-excel/${promotion?.promotionId}/${company}`,
      responseType: "arraybuffer",
      headers,
    };

    const exportPromise = axios(config).then(
      (response) =>
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
    );

    startUploadProcess(
      "",
      progressValue,
      setProgressValue,
      {
        placement: "bottomRight",
        duration: 2,
        label: "กำลังเตรียมไฟล์ของคุณ รอสักครู่!",
        progressInterval: 900,
      },
      async () => {
        try {
          const blob = await exportPromise;
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `${promotion?.promotionCode || "promotion"}.xlsx`;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          formatFileSize(blob.size);
        } catch (error) {
          console.log(error);
          message.error("Export โปรโมชันไม่สำเร็จ");
        }
      },
    );
  };

  return (
    <>
      <Row gutter={16}>
        <Col span={12}>
          <Descriptions
            label='สถานะ'
            value={
              <Tag color={promotion?.promotionStatus ? color.success : color.placeholder}>
                {promotion?.promotionStatus ? "Active" : "Inactive"}
              </Tag>
            }
          />
        </Col>
        <Col span={12}></Col>
        <Col span={12}>
          <Descriptions label='ชื่อโปรโมชัน' value={promotion?.promotionName} />
        </Col>
        <Col span={12}>
          <Descriptions
            label='ประเภทโปรโมชัน'
            value={
              promotion?.promotionType ? PROMOTION_TYPE_NAME[promotion?.promotionType] : undefined
            }
          />
        </Col>
        <Col span={12}>
          <Descriptions
            label='โควตารวม'
            value={
              promotion?.isQuotaAll && promotion.quota
                ? numberFormatter(
                    promotion.quota,
                    getQuotaUnit(promotion?.promotionType) == "สิทธิ์" ? 0 : 2,
                  ) +
                  " " +
                  getQuotaUnit(promotion?.promotionType)
                : getQuotaString(promotion?.isQuotaAll)
            }
          />
        </Col>
        <Col span={12}>
          <Descriptions label='โควตารายร้าน' value={getQuotaString(promotion?.isQuotaShop)} />
        </Col>
        {promotion?.isQuotaAll && (
          <>
            <Col span={12}>
              <Descriptions
                label='โควตารวมที่ใช้'
                value={
                  numberFormatter(
                    promotion?.quotaUsed,
                    getQuotaUnit(promotion?.promotionType) == "สิทธิ์" ? 0 : 2,
                  ) +
                  " " +
                  getQuotaUnit(promotion?.promotionType)
                }
              />
            </Col>
            <Col span={12} />
            <Col span={12}>
              <Descriptions
                label='โควตารวมที่เหลือ'
                value={
                  numberFormatter(
                    promotion?.quotaBalance || 0,
                    getQuotaUnit(promotion?.promotionType) == "สิทธิ์" ? 0 : 2,
                  ) +
                  " " +
                  getQuotaUnit(promotion?.promotionType)
                }
              />
            </Col>
            <Col span={12} />
          </>
        )}
        <Col span={12}>
          <Descriptions label='รหัสโปรโมชัน' value={promotion?.promotionCode} />
        </Col>
        <Col span={12}>
          <Descriptions
            label='อ้างอิงโปรโมชันที่เกี่ยวข้อง'
            value={promotion?.referencePromotion?.join(", ")}
          />
        </Col>
        <Col span={12}>
          <Descriptions
            label='ระยะเวลาใช้โปรโมชัน'
            value={
              moment(promotion?.startDate).locale("th").format("LLL") +
              " - " +
              moment(promotion?.endDate).locale("th").format("LLL")
            }
          />
        </Col>
      </Row>
      <Col span={12}>
        <Descriptions
          label='กำหนด Credit Term'
          value={
            promotion?.creditTermType === "NONE"
              ? "ไม่กำหนดเครดิต"
              : promotion?.creditTermType === "DAY"
                ? `${promotion?.creditTermValue} วัน`
                : `วันที่ชำระ ${dayjs(promotion?.creditTermValue).format("DD/MM/YYYY")}`
          }
        />
      </Col>
      {/* <Permission permission={["promotionSetting", "document"]}> */}
      <div>
        <br />
        <Row align='middle' gutter={16}>
          <Col span={12}>
            <Text level={5} fontWeight={700}>
              ไฟล์ Memo Promotion
            </Text>
          </Col>
          {isExcel && (
            <Col span={12}>
              <Text level={5} fontWeight={700}>
                ไฟล์ Excel
              </Text>
            </Col>
          )}
        </Row>
        <br />
        <Row align='middle' gutter={16}>
          <Col span={12}>
            <MemoArea>
              <Row align='middle' justify='space-between' style={{ width: "100%" }}>
                <Col span={16}>
                  <FlexRow align='center' style={{ height: "100%" }}>
                    &nbsp;&nbsp;&nbsp;
                    <svg
                      width='24'
                      height='31'
                      viewBox='0 0 24 31'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M20.0596 0.0175781L24 3.84855V5.85091V27.5176C24 28.8983 22.8487 30.0176 21.4286 30.0176H2.57143C1.15127 30.0176 0 28.8983 0 27.5176V2.51758C0 1.13687 1.15127 0.0175781 2.57143 0.0175781H18H20.0596ZM18 1.18424H2.57143C1.85609 1.18424 1.26867 1.71671 1.2056 2.39622L1.2 2.51758V27.5176C1.2 28.213 1.74768 28.7842 2.4466 28.8455L2.57143 28.8509H21.4286C22.1439 28.8509 22.7313 28.3184 22.7944 27.6389L22.8 27.5176V5.85091H18V1.18424ZM22.8 4.68424L22.8 4.33174L19.5626 1.18424H19.2V4.68424H22.8Z'
                        fill='#464E5F'
                      />
                      <path d='M4 15.6846H5.83333V17.5179H4V15.6846Z' fill='#464E5F' />
                      <path
                        d='M6.75 12.0176H8.98014C9.41286 12.0176 9.74294 12.0895 9.97039 12.2334C10.2034 12.372 10.3587 12.5718 10.4364 12.833C10.5196 13.0888 10.5612 13.4246 10.5612 13.8403C10.5612 14.24 10.5224 14.5704 10.4447 14.8315C10.367 15.0873 10.2117 15.2925 9.97871 15.4471C9.74571 15.5963 9.40731 15.6709 8.9635 15.6709H7.80682V17.5176H6.75V12.0176ZM8.614 14.7916C8.89138 14.7916 9.08832 14.7676 9.20482 14.7196C9.32687 14.6663 9.40454 14.5784 9.43782 14.4558C9.47665 14.3279 9.49607 14.1227 9.49607 13.8403C9.49607 13.5578 9.47665 13.3553 9.43782 13.2327C9.40454 13.1048 9.32964 13.0169 9.21314 12.9689C9.09664 12.9209 8.90248 12.8969 8.63064 12.8969H7.80682V14.7916H8.614Z'
                        fill='#464E5F'
                      />
                      <path
                        d='M11.4471 12.0176H13.1696C13.8741 12.0176 14.3734 12.0949 14.6674 12.2494C14.967 12.3986 15.1529 12.6491 15.225 13.0009C15.3027 13.3473 15.3415 13.9362 15.3415 14.7676C15.3415 15.599 15.3027 16.1905 15.225 16.5423C15.1529 16.8887 14.967 17.1392 14.6674 17.2937C14.3734 17.443 13.8741 17.5176 13.1696 17.5176H11.4471V12.0176ZM13.1197 16.6382C13.5246 16.6382 13.7965 16.6089 13.9352 16.5503C14.0794 16.4917 14.1709 16.3451 14.2098 16.1106C14.2542 15.8761 14.2763 15.4284 14.2763 14.7676C14.2763 14.1067 14.2542 13.6591 14.2098 13.4246C14.1709 13.1901 14.0794 13.0435 13.9352 12.9849C13.7965 12.9263 13.5246 12.8969 13.1197 12.8969H12.5039V16.6382H13.1197Z'
                        fill='#464E5F'
                      />
                      <path
                        d='M16.3879 17.5176V12.0176H19.5833V12.8969H17.4447V14.4318H19.3337V15.3192H17.4447V17.5176H16.3879Z'
                        fill='#464E5F'
                      />
                    </svg>
                    &nbsp;&nbsp;&nbsp;
                    <Text level={6} color='Text3'>
                      {promotion?.fileMemoPath
                        ? `${promotion.fileMemoPath.substring(0, 40)}...`
                        : "ไม่มีไฟล์แนบ"}
                    </Text>
                  </FlexRow>
                </Col>
                <Col span={8}>
                  <Buttons
                    title='ดูรายละเอียด'
                    icon={<EyeOutlined />}
                    onClick={() => {
                      const pdfWindow = window.open();
                      if (pdfWindow) pdfWindow.location.href = promotion?.fileMemoPath || "";
                    }}
                    disabled={!promotion?.fileMemoPath}
                    typeButton={promotion?.fileMemoPath ? "primary" : "disabled"}
                  />
                </Col>
              </Row>
            </MemoArea>
          </Col>
          {isExcel && (
            <Col span={12}>
              <MemoArea>
                <Row align='middle' justify='space-between' style={{ width: "100%" }}>
                  <Col span={16}>
                    <FlexRow align='center' style={{ height: "100%" }}>
                      &nbsp;&nbsp;&nbsp;
                      <FileExcelOutlined style={{ fontSize: 28 }} />
                      &nbsp;&nbsp;&nbsp;
                      <Text level={6} color='Text3'>
                        {`${promotion?.promotionCode}.xlsx`}
                      </Text>
                    </FlexRow>
                  </Col>
                  <Col span={8}>
                    <Buttons
                      title='ดาวน์โหลด'
                      icon={<DownloadOutlined style={{ color: "white" }} />}
                      onClick={onDownloadExcel}
                    />
                  </Col>
                </Row>
              </MemoArea>
            </Col>
          )}
        </Row>
        <br />
        <br />
      </div>
      {/* </Permission> */}
      <Divider />
      <Text level={2}>รายละเอียดรายการ</Text>
      <br />
      <br />
      <Row>
        <ToggleButton title='รายละเอียดโปรโมชัน' isSelected={showPromotion} />
        &nbsp;&nbsp;
        <ToggleButton title='เขตและร้านค้า' isSelected={!showPromotion} />
      </Row>
      <br />
      <br />
      {!showPromotion ? (
        <>
          <DetailRow content={`จำนวนร้านค้าทั้งหมด ${promotion?.promotionShop?.length} ร้าน`} />
          <TableContainer>
            <Table
              columns={columns.filter(({ hidden }) => !hidden)}
              dataSource={promotion?.promotionShop?.map((s) => ({ ...s, key: s.promotionShopId }))}
              pagination={false}
              scroll={{ y: 600 }}
            />
          </TableContainer>
        </>
      ) : (
        <>
          {promotion?.promotionType && (
            <DetailRow
              content={
                PromotionGroup.NOT_MIX.includes(promotion.promotionType)
                  ? `จำนวนสินค้าทั้งหมด ${promotion?.conditionDetail?.length} รายการ`
                  : `จำนวนกลุ่มสินค้า ${
                      promotion?.conditionDetail?.length || "-"
                    } กลุ่ม, จำนวนสินค้า ${promotion?.conditionDetail?.reduce(
                      (sum, current) => sum + (current?.products?.length || 0),
                      0,
                    )} รายการ`
              }
            />
          )}
          <Form layout='vertical'>
            {promotion?.promotionType === PromotionType.DISCOUNT_NOT_MIX_SET ? (
              <>
                {items?.map((item, i) => {
                  const currentKey = `promotion-${item.productId}`;
                  const { quantity, saleUnit, saleUnitDiscount, discountPrice } =
                    item?.condition as any;
                  return (
                    <>
                      <Collapse
                        collapsible='icon'
                        expandIconPosition='end'
                        expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />}
                      >
                        <Collapse.Panel
                          header={
                            <Row style={{ padding: "24px 32px" }}>
                              <Col span={10}>
                                <ProductName product={item as ProductEntity} size={84} />
                              </Col>
                              <Col span={5}>
                                <Text>{item.packSize}</Text>
                                <br />
                                <Text color='Text3'>
                                  {!loadingProduct
                                    ? priceFormatter(item.unitPrice || "", 2, false, true)
                                    : "..."}
                                </Text>
                                <Text color='Text3'>&nbsp;บาท/หน่วย</Text>
                                <br />
                                <Text color='Text3'>
                                  {!loadingProduct
                                    ? priceFormatter(item.marketPrice || "", 2, false, true)
                                    : "..."}
                                </Text>
                                <Text color='Text3'>&nbsp;บาท/{item.saleUOMTH}</Text>
                              </Col>
                              <Col span={8}></Col>
                            </Row>
                          }
                          key={item.productId}
                        >
                          <Row gutter={16} style={{ padding: "20px 16px" }}>
                            <Col span={8}>
                              <Form.Item
                                label='จำนวนที่ซื้อครบ'
                                name={[`${i}`, "quantity"]}
                                initialValue={quantity}
                              >
                                <Input
                                  type='number'
                                  placeholder='ระบุจำนวนที่ซื้อครบ'
                                  min={0}
                                  disabled
                                />
                              </Form.Item>
                            </Col>
                            <Col span={4}>
                              <Form.Item
                                label='หน่วย'
                                name={[`${i}`, "saleUnit"]}
                                initialValue={item.saleUOMTH}
                              >
                                <Input disabled />
                              </Form.Item>
                            </Col>

                            <Col span={6}>
                              <Form.Item
                                label='ราคาที่ต้องการลด'
                                name={[`${i}`, "discountPrice"]}
                                extra={`ราคาขายหลังหักส่วนลด ${
                                  parseFloat(item.marketPrice || "") -
                                  parseFloat(`${discountPrice || 0}`)
                                } บาท / ${item.saleUOMTH}`}
                                initialValue={discountPrice}
                              >
                                <Input placeholder='-' suffix='บาท' type='number' disabled />
                              </Form.Item>
                            </Col>
                            <Col span={6}>
                              <Form.Item
                                label='ต่อหน่วย SKU'
                                name={[`${i}`, "saleUnitDiscount"]}
                                initialValue={item.saleUOMTH}
                              >
                                <Input disabled />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Collapse.Panel>
                      </Collapse>
                      <br />
                      {i < items.length - 1 && (
                        <>
                          <Text level={5} color='Text3' fontWeight={700}>
                            ซื้อร่วมกับ
                          </Text>
                          <br />
                          <br />
                        </>
                      )}
                    </>
                  );
                })}
              </>
            ) : promotion && PromotionGroup.MIX.includes(promotion?.promotionType) ? (
              promotion.conditionDetail &&
              Object.values(promotion?.conditionDetail as PromotionConditionGroupEntity[]).map(
                ({ products, conditionDiscount, conditionFreebies, detail }, i) => {
                  const getType = promotion?.promotionType;
                  const typeMix =
                    getType === PromotionType.DISCOUNT_MIX
                      ? promotion.conditionDetail &&
                        promotion?.conditionDetail[0].conditionDiscount.typeMix
                      : promotion.conditionDetail && promotion?.conditionDetail[0]?.typeMix;
                  const size =
                    getType === PromotionType.DISCOUNT_MIX
                      ? promotion.conditionDetail &&
                        promotion?.conditionDetail[i].conditionDiscount.size
                      : promotion.conditionDetail && promotion?.conditionDetail[i]?.size;
                  return (
                    <GroupCardContainer key={i}>
                      <Card
                        title={
                          <Row align='middle'>
                            <Col span={3} style={{ padding: "8px 0px" }}>
                              <Text color='white'>สินค้ากลุ่ม {i + 1}</Text>
                            </Col>
                            <Col span={3} style={{ lineHeight: "40px" }}>
                              <Text color='white' fontSize={12}>
                                สินค้าทั้งหมด {products?.length} รายการ
                              </Text>
                            </Col>
                            <Col span={3} style={{ lineHeight: "40px" }}>
                              {/* <Text color='white' fontSize={12}>
                                จำนวน 1 ขั้นบันได
                              </Text> */}
                            </Col>
                          </Row>
                        }
                      >
                        {typeMix === PromotionGroupOption.WEIGHT && size && (
                          <div
                            style={{
                              backgroundColor: "#3362AA",
                              width: "100%",
                              padding: "16px",
                              height: 96,
                            }}
                          >
                            <Form>
                              <Row gutter={16}>
                                <Col span={5}>
                                  <Form.Item
                                    label={
                                      <Text color='white' fontSize={14}>
                                        จำนวนน้ำหนักที่ซื้อครบ
                                      </Text>
                                    }
                                    initialValue={size}
                                  >
                                    <Input
                                      value={size}
                                      disabled
                                      style={{ backgroundColor: color.white }}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={4}>
                                  <Form.Item
                                    label={
                                      <Text color='white' fontSize={14}>
                                        หน่วย
                                      </Text>
                                    }
                                  >
                                    <Input
                                      disabled
                                      value={"kg / L"}
                                      style={{ backgroundColor: color.white }}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Form>
                          </div>
                        )}
                        {promotion.promotionType === PromotionType.DISCOUNT_MIX_RANGE && (
                          <div
                            style={{
                              backgroundColor: "#3362AA",
                              width: "100%",
                              padding: "16px 16px 0 16px",
                            }}
                          >
                            <Row gutter={16}>
                              <Col span={5}>
                                <Form.Item
                                  label={
                                    <Text color='white' fontSize={14}>
                                      จำนวนขั้นต่ำที่ซื้อครบ
                                    </Text>
                                  }
                                  initialValue={conditionDiscount?.min}
                                >
                                  <Input
                                    disabled
                                    value={conditionDiscount?.min}
                                    style={{ backgroundColor: "white", color: "black" }}
                                  />
                                </Form.Item>
                              </Col>
                              <Col>
                                <FlexCol align='center' justify='center' style={{ height: "100%" }}>
                                  <Text level={6} color='white'>
                                    ถึง
                                  </Text>
                                </FlexCol>
                              </Col>
                              <Col span={5}>
                                <Form.Item
                                  label={
                                    <Text color='white' fontSize={14}>
                                      จำนวนสูงสุดที่ซื้อครบ
                                    </Text>
                                  }
                                  initialValue={conditionDiscount?.max}
                                >
                                  <Input
                                    disabled
                                    value={conditionDiscount?.max}
                                    style={{ backgroundColor: "white", color: "black" }}
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={4}>
                                <Form.Item
                                  label={
                                    <Text color='white' fontSize={14}>
                                      หน่วย
                                    </Text>
                                  }
                                >
                                  <Input
                                    disabled
                                    value={"ลัง/กระสอบ"}
                                    style={{ backgroundColor: "white", color: "black" }}
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                          </div>
                        )}
                        <div style={{ backgroundColor: color.background1 }}>
                          {products?.map((item: ProductEntity, j: number) => {
                            const data = { ...item };
                            if (
                              (promotion.promotionType === PromotionType.DISCOUNT_MIX &&
                                typeMix === PromotionGroupOption.WEIGHT) ||
                              promotion.promotionType === PromotionType.DISCOUNT_MIX_RANGE
                            ) {
                              const discountPrice = conditionDiscount.products.find(
                                (x: any) => x.productId === data.productId,
                              ).discountPrice;
                              data.discountPrice = discountPrice;
                            }
                            return (
                              <CollapsePanelHeader
                                item={data}
                                selectedKeys={[]}
                                setSelectedKeys={() => ""}
                                loadingProduct={loadingProduct}
                                rowsCount={0}
                                hideCheckbox
                                uneditable
                                viewOnly
                                promotionType={promotion?.promotionType}
                                key={j}
                                withForm={
                                  (promotion.promotionType === PromotionType.DISCOUNT_MIX &&
                                    typeMix === PromotionGroupOption.WEIGHT) ||
                                  promotion.promotionType === PromotionType.DISCOUNT_MIX_RANGE
                                    ? form
                                    : undefined
                                }
                                promotionGroupOption={typeMix}
                                groupKey={`${item.groupKey}`}
                              />
                            );
                          })}
                        </div>
                        {Array.isArray(conditionDiscount || conditionFreebies) &&
                          (conditionDiscount || conditionFreebies)?.map(
                            (
                              {
                                quantity,
                                saleUnit,
                                saleUnitDiscount,
                                discountPrice,
                                freebies,
                              }: PromotionConditionEntity,
                              j: number,
                            ) => {
                              const renderType = (typeMix: string) => {
                                if (typeMix === "Size") {
                                  return (
                                    <Row key={j} gutter={16} style={{ padding: "20px 16px" }}>
                                      {freebies ? (
                                        <>
                                          <Col span={24}>
                                            {freebies?.map((f, k) => {
                                              return (
                                                <Row
                                                  key={`${i}-${j}-${k}`}
                                                  gutter={12}
                                                  align='middle'
                                                >
                                                  <Col span={2}>
                                                    <FlexCol
                                                      align='center'
                                                      style={{ width: 64, overflow: "hidden" }}
                                                    >
                                                      <Avatar
                                                        src={
                                                          f.productImage === "No"
                                                            ? image.product_no_image
                                                            : f?.productImage ||
                                                              f?.productFreebiesImage ||
                                                              image.product_no_image
                                                        }
                                                        size={64}
                                                        shape='square'
                                                      />
                                                    </FlexCol>
                                                  </Col>
                                                  <Col span={6}>
                                                    <Text>{f?.productName}</Text>
                                                    <br />
                                                    {f?.commonName && (
                                                      <Text level={6} color={"Text3"}>
                                                        {f?.commonName}
                                                      </Text>
                                                    )}
                                                    <Text level={6} color={"Text3"}>
                                                      Product Group : {f?.productGroup}
                                                    </Text>
                                                    <br />
                                                    {f.productStrategy && (
                                                      <Text level={6} color={"Text3"}>
                                                        Startegy Group : {f?.productStrategy}
                                                      </Text>
                                                    )}
                                                  </Col>
                                                  <Col span={8}>
                                                    <Form.Item
                                                      label='จำนวนของแถม'
                                                      initialValue={quantity || 1}
                                                    >
                                                      <Input
                                                        type='number'
                                                        placeholder='ระบุจำนวนของแถม'
                                                        value={f.quantity}
                                                        min={0}
                                                        disabled
                                                      />
                                                    </Form.Item>
                                                  </Col>
                                                  <Col span={8}>
                                                    <Form.Item
                                                      label='หน่วย'
                                                      initialValue={
                                                        f?.baseUnitOfMeaTh ||
                                                        f?.saleUOMTH ||
                                                        f?.baseUnitOfMeaEn
                                                      }
                                                    >
                                                      <Input
                                                        disabled
                                                        value={
                                                          f?.baseUnitOfMeaTh ||
                                                          f?.saleUOMTH ||
                                                          f?.baseUnitOfMeaEn
                                                        }
                                                      />
                                                    </Form.Item>
                                                  </Col>
                                                </Row>
                                              );
                                            })}
                                          </Col>
                                        </>
                                      ) : (
                                        <>
                                          <Col span={6}>
                                            <Form.Item
                                              label='ราคาที่ต้องการลด'
                                              name={[`${i}-${j}`, "discountPrice"]}
                                              initialValue={discountPrice}
                                            >
                                              <Input
                                                placeholder='-'
                                                suffix='บาท'
                                                type='number'
                                                disabled
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col span={6}>
                                            <Form.Item
                                              label='ต่อหน่วย SKU'
                                              name={[`${i}-${j}`, "saleUnitDiscount"]}
                                              initialValue={
                                                saleUnitDiscount ||
                                                (products && products[0].saleUOMTH)
                                              }
                                            >
                                              <Input disabled />
                                            </Form.Item>
                                          </Col>
                                        </>
                                      )}
                                    </Row>
                                  );
                                } else {
                                  return (
                                    <Row key={j} gutter={16} style={{ padding: "20px 16px" }}>
                                      <Col span={8}>
                                        <Form.Item
                                          label='จำนวนที่ซื้อครบ'
                                          name={[`${i}-${j}`, "quantity"]}
                                          initialValue={quantity}
                                        >
                                          <Input
                                            type='number'
                                            placeholder='ระบุจำนวนที่ซื้อครบ'
                                            min={0}
                                            disabled
                                          />
                                        </Form.Item>
                                      </Col>
                                      <Col span={4}>
                                        <Form.Item
                                          label='หน่วย'
                                          name={[`${i}-${j}`, "saleUnit"]}
                                          initialValue={
                                            saleUnit || (products && products[0].saleUOMTH)
                                          }
                                        >
                                          <Input disabled />
                                        </Form.Item>
                                      </Col>

                                      {freebies ? (
                                        <>
                                          <Col
                                            span={12}
                                            style={{ borderLeft: `1px solid ${color.background2}` }}
                                          >
                                            {freebies?.map((f, k) => {
                                              return (
                                                <Row
                                                  key={`${i}-${j}-${k}`}
                                                  gutter={12}
                                                  align='middle'
                                                >
                                                  <Col>
                                                    <FlexCol
                                                      align='center'
                                                      style={{ width: 64, overflow: "hidden" }}
                                                    >
                                                      <Avatar
                                                        src={
                                                          f.productImage === "No"
                                                            ? image.product_no_image
                                                            : f?.productImage ||
                                                              f?.productFreebiesImage ||
                                                              image.product_no_image
                                                        }
                                                        size={64}
                                                        shape='square'
                                                      />
                                                      <Tooltip title={f?.productName}>
                                                        <Text
                                                          level={6}
                                                          style={{
                                                            display: "block",
                                                            width: 64,
                                                            height: 22,
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            wordWrap: "break-word",
                                                            whiteSpace: "nowrap",
                                                          }}
                                                        >
                                                          {f?.productName}
                                                        </Text>
                                                      </Tooltip>
                                                    </FlexCol>
                                                  </Col>
                                                  <Col span={9}>
                                                    <Form.Item
                                                      // name={`${productId}-${product?.productId || product?.productFreebiesId}-quantity`}
                                                      label='จำนวนของแถม'
                                                      initialValue={quantity || 1}
                                                    >
                                                      <Input
                                                        type='number'
                                                        placeholder='ระบุจำนวนของแถม'
                                                        value={f.quantity}
                                                        min={0}
                                                        disabled
                                                      />
                                                    </Form.Item>
                                                  </Col>
                                                  <Col span={9}>
                                                    <Form.Item
                                                      label='หน่วย'
                                                      initialValue={
                                                        f?.baseUnitOfMeaTh ||
                                                        f?.saleUOMTH ||
                                                        f?.baseUnitOfMeaEn
                                                      }
                                                    >
                                                      <Input
                                                        disabled
                                                        value={
                                                          f?.baseUnitOfMeaTh ||
                                                          f?.saleUOMTH ||
                                                          f?.baseUnitOfMeaEn
                                                        }
                                                      />
                                                    </Form.Item>
                                                  </Col>
                                                </Row>
                                              );
                                            })}
                                          </Col>
                                        </>
                                      ) : (
                                        <>
                                          <Col span={6}>
                                            <Form.Item
                                              label='ราคาที่ต้องการลด'
                                              name={[`${i}-${j}`, "discountPrice"]}
                                              initialValue={discountPrice}
                                            >
                                              <Input
                                                placeholder='-'
                                                suffix='บาท'
                                                type='number'
                                                disabled
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col span={6}>
                                            <Form.Item
                                              label='ต่อหน่วย SKU'
                                              name={[`${i}-${j}`, "saleUnitDiscount"]}
                                              initialValue={
                                                saleUnitDiscount ||
                                                (products && products[0].saleUOMTH)
                                              }
                                            >
                                              <Input disabled />
                                            </Form.Item>
                                          </Col>
                                        </>
                                      )}
                                    </Row>
                                  );
                                }
                              };
                              return renderType(typeMix);
                            },
                          )}
                        {detail && (
                          <div style={{ padding: "20px 16px" }}>
                            <Form.Item label='รายละเอียดโปรโมชัน'>
                              <TextArea
                                disabled
                                value={detail}
                                readOnly
                                style={{ height: 120, resize: "none" }}
                              />
                            </Form.Item>
                          </div>
                        )}
                      </Card>
                    </GroupCardContainer>
                  );
                },
              )
            ) : (
              <Collapse
                collapsible='icon'
                expandIconPosition='end'
                expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />}
              >
                {items?.map((item, i) => {
                  const { condition } = item;
                  return (
                    <Collapse.Panel
                      header={
                        <Row style={{ padding: "24px 32px" }}>
                          <Col span={10}>
                            <ProductName product={item as ProductEntity} size={84} />
                          </Col>
                          <Col span={5}>
                            <Text>{item.packSize}</Text>
                            <br />
                            <Text color='Text3'>
                              {!loadingProduct
                                ? priceFormatter(item.unitPrice || "", 2, false, true)
                                : "..."}
                            </Text>
                            <Text color='Text3'>&nbsp;บาท/หน่วย</Text>
                            <br />
                            <Text color='Text3'>
                              {!loadingProduct
                                ? priceFormatter(item.marketPrice || "", 2, false, true)
                                : "..."}
                            </Text>
                            <Text color='Text3'>&nbsp;บาท/{item.saleUOMTH}</Text>
                          </Col>
                          <Col span={8}>
                            {item?.condition?.length && (
                              <Text>จำนวน&nbsp;{item?.condition?.length}&nbsp;ขั้นบันได</Text>
                            )}
                          </Col>
                        </Row>
                      }
                      key={i}
                    >
                      {condition?.map(
                        ({ quantity, saleUnit, saleUnitDiscount, discountPrice, freebies }, j) => {
                          return (
                            <Row key={j} gutter={16} style={{ padding: "20px 16px" }}>
                              <Col span={8}>
                                <Form.Item
                                  label='จำนวนที่ซื้อครบ'
                                  name={[`${i}-${j}`, "quantity"]}
                                  initialValue={quantity}
                                >
                                  <Input
                                    type='number'
                                    placeholder='ระบุจำนวนที่ซื้อครบ'
                                    min={0}
                                    disabled
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={4}>
                                <Form.Item
                                  label='หน่วย'
                                  name={[`${i}-${j}`, "saleUnit"]}
                                  initialValue={item.saleUOMTH}
                                >
                                  <Input disabled />
                                </Form.Item>
                              </Col>
                              {freebies ? (
                                <>
                                  <Col
                                    span={12}
                                    style={{ borderLeft: `1px solid ${color.background2}` }}
                                  >
                                    {freebies?.map((f, k) => {
                                      return (
                                        <Row key={`${i}-${j}-${k}`} gutter={12} align='middle'>
                                          <Col>
                                            <FlexCol
                                              align='center'
                                              style={{ width: 64, overflow: "hidden" }}
                                            >
                                              <Avatar
                                                src={
                                                  f.productImage === "No"
                                                    ? image.product_no_image
                                                    : f?.productImage ||
                                                      f?.productFreebiesImage ||
                                                      image.product_no_image
                                                }
                                                size={64}
                                                shape='square'
                                              />
                                              <Tooltip title={f?.productName}>
                                                <Text
                                                  level={6}
                                                  style={{
                                                    display: "block",
                                                    width: 64,
                                                    height: 22,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    wordWrap: "break-word",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  {f?.productName}
                                                </Text>
                                              </Tooltip>
                                            </FlexCol>
                                          </Col>
                                          <Col span={9}>
                                            <Form.Item
                                              // name={`${productId}-${product?.productId || product?.productFreebiesId}-quantity`}
                                              label='จำนวนของแถม'
                                              initialValue={quantity || 1}
                                            >
                                              <Input
                                                type='number'
                                                placeholder='ระบุจำนวนของแถม'
                                                value={f.quantity}
                                                min={0}
                                                disabled
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col span={9}>
                                            <Form.Item
                                              label='หน่วย'
                                              initialValue={
                                                f?.baseUnitOfMeaTh ||
                                                f?.saleUOMTH ||
                                                f?.baseUnitOfMeaEn
                                              }
                                            >
                                              <Input
                                                disabled
                                                value={
                                                  f?.baseUnitOfMeaTh ||
                                                  f?.saleUOMTH ||
                                                  f?.baseUnitOfMeaEn
                                                }
                                              />
                                            </Form.Item>
                                          </Col>
                                        </Row>
                                      );
                                    })}
                                  </Col>
                                </>
                              ) : (
                                <>
                                  <Col span={6}>
                                    <Form.Item
                                      label='ราคาที่ต้องการลด'
                                      name={[`${i}-${j}`, "discountPrice"]}
                                      extra={`ราคาขายหลังหักส่วนลด ${
                                        parseFloat(item.marketPrice || "") -
                                        parseFloat(`${discountPrice || 0}`)
                                      } บาท / ${item.saleUOMTH}`}
                                      initialValue={discountPrice}
                                    >
                                      <Input placeholder='-' suffix='บาท' type='number' disabled />
                                    </Form.Item>
                                  </Col>
                                  <Col span={6}>
                                    <Form.Item
                                      label='ต่อหน่วย SKU'
                                      name={[`${i}-${j}`, "saleUnitDiscount"]}
                                      initialValue={item.saleUOMTH}
                                    >
                                      <Input disabled />
                                    </Form.Item>
                                  </Col>
                                </>
                              )}
                            </Row>
                          );
                        },
                      )}
                    </Collapse.Panel>
                  );
                })}
              </Collapse>
            )}
          </Form>
        </>
      )}
    </>
  );
};

export const DetailApp: React.FC<DetailTabProps> = ({ data, onUpdate }) => {
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const [form] = Form.useForm();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [isDone, setIsDone] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [imgPromotion, setImgPromotion] = useState<any>(data?.promotionImageSecond);
  const [imgFile, setImgFile] = useState<any>(undefined);
  const [imgUrl, setImgUrl] = useState<boolean>(data?.promotionImageSecond);
  const date = data?.startDate;
  const isShowPromotion = Form.useWatch("isShowPromotion", form);

  const checkDate = () => {
    const datePro = dayjs(date);
    const current = dayjs(new Date());
    const final = !isShowPromotion ? true : current > datePro ? true : false;
    return final;
  };

  const mapDataInform = () => {
    form.setFieldsValue({
      isShowPromotion: data?.isShowPromotion,
      isShowSaleApp: data?.isShowSaleApp,
      isShowShopApp: data?.isShowShopApp,
      promotionNotiDetail: data?.promotionNotiDetail,
      promotionSubject: data?.promotionSubject,
      promotionDetail: data?.promotionDetail,
      promotionNotiSubject: data?.promotionNotiSubject,
      startDate: dayjs(data?.startDate),
      firstDateNoti: data?.notiFirstDate ? dayjs(data?.notiFirstDate) : null,
      firstTimeNoti: data?.notiFirstDate ? dayjs(data?.notiFirstDate) : null,
      secondDateNoti: data?.startDate ? dayjs(data?.startDate) : null,
      secondTimeNoti: data?.notiSecondDate ? dayjs(data?.notiSecondDate) : null,
      promotionStatus: data?.promotionStatus,
    });
  };

  useEffect(() => {
    mapDataInform();
    setTimeout(() => {
      setLoading(false);
      setImgPromotion(data?.promotionImageSecond ? data?.promotionImageSecond : undefined);
      setImgUrl(data?.promotionImageSecond ? true : false);
    }, 500);
  }, [data]);

  const validateData = async (checked?: boolean) => {
    return await form
      .validateFields()
      .then((value) => true)
      .catch((errInfo) => {
        console.log("errInfo", errInfo);
        return false;
      });
  };

  const isUrl = (img: any) => {
    try {
      new URL(img);
      setImgUrl(true);
      return true;
    } catch {
      setImgUrl(false);
      return false;
    }
  };

  const savePromotionApp = async () => {
    const valid = await validateData(true);
    if (imgPromotion && valid) {
      form
        .validateFields()
        .then(async (detail) => {
          const values = form.getFieldsValue(true);
          values.promotionId = data.promotionId;
          // (values.notiFirstDate =
          //   values.firstDateNoti && values.firstTimeNoti
          //     ? dayjs(
          //         `${values.firstDateNoti.format("YYYY-MM-DD")} ${values.firstTimeNoti.format("HH:mm")}:00.000`,
          //       ).toISOString()
          //     : undefined),
          //   (values.notiSecondDate =
          //     values.secondDateNoti && values.secondTimeNoti
          //       ? dayjs(
          //           `${values.secondDateNoti.format("YYYY-MM-DD")} ${values.secondTimeNoti.format("HH:mm")}:00.000`,
          //         ).toISOString()
          //       : undefined);
          values.company = data.company;
          values.promotionName = data.promotionName;
          values.promotionCode = data.promotionCode;
          values.updateBy = `${userProfile.firstname} ${userProfile.lastname}`;

          const formData = new FormData();
          formData.append("promotionId", data.promotionId);
          formData.append("promotionImageSecondCheck", imgUrl ? "false" : "true");
          formData.append("promotionImageSecond", imgFile);
          await updatePromotionFile(formData)
            .then((res) => res)
            .catch((err) => {
              console.log("updatePromotionFile", err);
              throw err;
            });

          await updatePromotionImage(values)
            .then(async (res) => {
              setIsDone(true);
              setTimeout(() => setIsDone(false), 1500);
              if (onUpdate) {
                await onUpdate();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((errInfo) => {
          console.log("errInfo", errInfo);
        });
    }
  };

  return (
    <>
      <Form
        layout='vertical'
        initialValues={{
          isShowSaleApp: data?.isShowSaleApp,
          isShowShopApp: data?.isShowShopApp,
          isShowPromotion: data?.isShowPromotion,
        }}
        form={form}
      >
        <Row gutter={16}>
          <Col>
            <Text level={5} fontWeight={700}>
              ตั้งค่าแสดงโปรโมชันในแอปพลิเคชัน
            </Text>
          </Col>
          <Col>
            <Form.Item name='isShowPromotion' valuePropName='checked'>
              <Switch
                checked={isShowPromotion}
                onChange={async (e) => {
                  if (!e) {
                    form.setFields([
                      { name: "promotionSubject", errors: [] },
                      { name: "promotionNotiSubject", errors: [] },
                      { name: "promotionNotiDetail", errors: [] },
                      { name: "isShowSaleApp", errors: [] },
                      { name: "isShowShopApp", errors: [] },
                    ]);
                    setImgPromotion(data?.promotionImageSecond || undefined);
                    await mapDataInform();
                  }
                  form.setFieldsValue({ isShowPromotion: e });
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <div
          style={{
            backgroundColor: isShowPromotion ? "#FBFDFF" : "#E5EAEE",
            borderRadius: "5px",
            padding: "10px",
          }}
        >
          <Row>
            <Col span={18}>
              <Text level={5} fontWeight={700}>
                รายละเอียดการแสดงผล
              </Text>
            </Col>
            <Col span={6}>
              <Text level={5} fontWeight={700}>
                <BellOutlined /> รายละเอียดการแสดงผล
              </Text>
            </Col>
          </Row>
          <Row justify='space-between' gutter={8}>
            <Col span={4}>
              <FlexCol>
                <FlexRow style={{ height: 152 }}>
                  <FlexCol style={{ marginRight: 16 }}>
                    <FlexRow
                      style={{
                        height: 22,
                      }}
                    >
                      <span style={{ color: color.error }}>*</span>รูปภาพประกอบโปรโมชัน
                    </FlexRow>
                    <FlexRow style={{ height: 130 }}>
                      <Form.Item noStyle valuePropName='file'>
                        {isShowPromotion ? (
                          <ImgCrop aspect={16 / 9} {...imgCropProps}>
                            <UploadHorizontal
                              style={{
                                width: "220px",
                                height: "130px",
                              }}
                              listType='picture-card'
                              maxCount={1}
                              beforeUpload={(file) => {
                                const isJpgOrPng =
                                  file.type === "image/jpeg" || file.type === "image/png";
                                if (!isJpgOrPng) {
                                  message.error("You can only upload JPG/PNG file!");
                                  return true;
                                }
                                isUrl(file);
                                setImgFile(file);
                                getBase64(file as RcFile, async (url) => {
                                  //const resized = await resizeBase64Image(url, 1200, 675);
                                  //console.log("resized", resized);
                                  setImgPromotion(url);
                                });
                              }}
                              customRequest={(file) => {
                                console.log("customRequest");
                              }}
                              onChange={({ file }: any) => {
                                return "success";
                              }}
                              onRemove={() => {
                                setImgFile(undefined);
                              }}
                              showUploadList={false}
                              disabled={!!imgPromotion}
                            >
                              {!imgPromotion ? (
                                <>
                                  <UploadArea
                                    style={{
                                      width: "220px",
                                      height: "130px",
                                      borderColor: imgPromotion ? color.error : color.Text3,
                                    }}
                                  >
                                    {UploadIcon}
                                  </UploadArea>
                                </>
                              ) : (
                                <Spin spinning={loading}>
                                  <ImageWithDeleteButton
                                    width='220px'
                                    height='130px'
                                    src={imgPromotion}
                                    handleDelete={() => {
                                      setImgFile(undefined);
                                      setImgPromotion(undefined);
                                    }}
                                  />
                                </Spin>
                              )}
                            </UploadHorizontal>
                          </ImgCrop>
                        ) : (
                          <>
                            {!imgPromotion ? (
                              <UploadArea
                                style={{
                                  width: "220px",
                                  height: "130px",
                                }}
                              >
                                {UploadIcon}
                              </UploadArea>
                            ) : (
                              <Image
                                style={{
                                  width: "220px",
                                  height: "130px",
                                  borderRadius: 4,
                                  filter: "grayscale(100%)",
                                }}
                                src={imgPromotion}
                              />
                            )}
                          </>
                        )}
                      </Form.Item>
                    </FlexRow>
                  </FlexCol>
                </FlexRow>
                {!imgPromotion && isShowPromotion && (
                  <FlexRow style={{ height: 22 }}>
                    <Text level={6} style={{ color: color.error }}>
                      กรุณาใส่รูปภาพโปรโมชัน
                    </Text>
                  </FlexRow>
                )}
              </FlexCol>
              <FlexCol style={{ marginRight: 32 }}>
                <Text level={6} color='Text3'>
                  JPG, GIF or PNG. Size of
                  <br />
                  Size of 1200*675 px
                  <br />
                  (16:9)
                </Text>
              </FlexCol>
              <Col style={{ paddingTop: 50 }}>
                <Text level={5} fontWeight={700}>
                  แสดงในแอปพลิเคชัน
                </Text>
                <Form.Item
                  name='isShowSaleApp'
                  valuePropName='checked'
                  rules={[
                    {
                      validator: (rule, value, callback) => {
                        if (isShowPromotion) {
                          const isShowShopApp = form.getFieldValue("isShowShopApp");
                          if (!isShowShopApp && !value) {
                            return Promise.reject("*กรุณาเลือก");
                          }
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Checkbox disabled={!isShowPromotion}>Sale App</Checkbox>
                </Form.Item>
                <Form.Item
                  name='isShowShopApp'
                  valuePropName='checked'
                  rules={[
                    {
                      validator: (rule, value, callback) => {
                        if (isShowPromotion) {
                          const isShowSaleApp = form.getFieldValue("isShowSaleApp");
                          if (!value && !isShowSaleApp) {
                            return Promise.reject("*กรุณาเลือก");
                          }
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                  style={{ marginTop: "-16px" }}
                >
                  <Checkbox disabled={!isShowPromotion}>Shop App</Checkbox>
                </Form.Item>
              </Col>
            </Col>
            <Col span={12}>
              <Col>
                <Form.Item
                  name='promotionSubject'
                  label='ชื่อเรื่องโปรโมชัน'
                  rules={[
                    {
                      required: isShowPromotion,
                      message: "*โปรดระบุชื่อเรื่องโปรโมชัน",
                    },
                  ]}
                >
                  <Input
                    placeholder='ระบุชื่อเรื่องโปรโมชัน'
                    disabled={!isShowPromotion}
                    autoComplete='off'
                  />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item name='promotionDetail' label='รายละเอียดโปรโมชัน'>
                  <TextArea
                    placeholder='ระบุรายละเอียด'
                    disabled={!isShowPromotion}
                    autoComplete='off'
                  />
                </Form.Item>
              </Col>
              <Col>
                <Text level={5} fontWeight={700}>
                  ดูภาพการแสดงผลในแอปพลิเคชัน
                </Text>
                <br />
                <Button
                  style={{
                    color: isShowPromotion ? color.primary : color.Disable,
                    borderColor: isShowPromotion ? color.primary : color.Disable,
                  }}
                  onClick={() => {
                    setShowModal(!showModal);
                  }}
                  disabled={!isShowPromotion}
                >
                  <EyeOutlined style={{ fontSize: "18px" }} />
                  ดูภาพ
                </Button>
              </Col>
            </Col>
            <Col span={6}>
              <Col>
                <Form.Item
                  name='promotionNotiSubject'
                  label='พาดหัวแจ้งเตือน'
                  // rules={[
                  //   {
                  //     required: isShowPromotion,
                  //     message: "*โปรดระบุพาดหัวแจ้งเตือน",
                  //   },
                  // ]}
                >
                  <TextArea
                    placeholder='ระบุพาดหัวแจ้งเตือน'
                    disabled={!isShowPromotion}
                    maxLength={50}
                    showCount
                    autoSize={{ minRows: 1, maxRows: 1 }}
                    autoComplete='off'
                  />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item
                  name='promotionNotiDetail'
                  label='รายละเอียดแจ้งเตือน'
                  // rules={[
                  //   {
                  //     required: isShowPromotion,
                  //     message: "*โปรดระบุรายละเอียดพาดหัว",
                  //   },
                  // ]}
                >
                  <TextArea
                    placeholder='ระบุรายละเอียดพาดหัวแจ้งเตือน'
                    disabled={!isShowPromotion}
                    maxLength={150}
                    showCount
                    autoComplete='off'
                  />
                </Form.Item>
              </Col>
              {/* <Col>
                แจ้งเตือน ก่อนเริ่มโปรโมชัน{" "}
                <span>
                  <Tooltip
                    placement='top'
                    title='หมายเหตุ: ถ้าไม่มีการระบุวันที่แจ้งเตือนก่อนเริ่มโปรโมชันจะไม่มีแสดงผลแจ้งเตือนไปที่แอปพลิเคชัน'
                  >
                    <ExclamationCircleOutlined />
                  </Tooltip>
                </span>
              </Col>
              <Row gutter={8}>
                <Col span={12}>
                  <Form.Item name='firstDateNoti'>
                    <DatePicker
                      style={{ width: "100%" }}
                      disabledDate={(current: Dayjs) => {
                        const startDate = form.getFieldValue("startDate");
                        const dateToday = dayjs(new Date());
                        return current.isBefore(dateToday) || current.isAfter(dayjs(startDate));
                      }}
                      enablePast
                      disabled={checkDate()}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name='firstTimeNoti' initialValue={dayjs("07:00", "HH:mm")}>
                    <TimePicker disabled={checkDate()} />
                  </Form.Item>
                </Col>
              </Row>
              <Col>
                <label>แจ้งเตือน วันที่เริ่มโปรโมชัน</label>
              </Col>
              <Row gutter={8}>
                <Col span={12}>
                  <Form.Item name='startDate'>
                    <DatePicker
                      style={{ width: "100%" }}
                      enablePast
                      disabled
                      placeholder='วันที่เริ่มโปรโมชัน'
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name='secondTimeNoti' initialValue={dayjs("07:00", "HH:mm")}>
                    <TimePicker allowClear={false} disabled={checkDate()} />
                  </Form.Item>
                </Col>
              </Row> */}
            </Col>
          </Row>
        </div>
      </Form>
      <Divider />
      <Row justify='end' gutter={12}>
        <Col>
          <Button
            onClick={async () => {
              form.setFields([
                { name: "promotionSubject", errors: [] },
                { name: "promotionNotiSubject", errors: [] },
                { name: "promotionNotiDetail", errors: [] },
                { name: "isShowSaleApp", errors: [] },
                { name: "isShowShopApp", errors: [] },
              ]);
              setImgPromotion(data?.promotionImageSecond || undefined);
              await mapDataInform();
            }}
            style={{
              borderColor: color.primary,
              height: 40,
            }}
          >
            <Text color={"primary"}>ยกเลิก</Text>
          </Button>
        </Col>
        <Col>
          <Button
            onClick={() => savePromotionApp()}
            style={{
              borderColor: color.primary,
              backgroundColor: color.primary,
              height: 40,
            }}
          >
            <Text color={"white"}>บันทึก</Text>
          </Button>
        </Col>
      </Row>
      {showModal && (
        <Modal
          open={showModal}
          onCancel={() => setShowModal(!showModal)}
          footer={false}
          width={600}
        >
          <Row justify={"space-between"} gutter={8} className='pt-3'>
            <Col span={12}>
              <div
                style={{
                  borderColor: color.Disable,
                  border: "solid",
                  borderRadius: "22px",
                }}
              >
                <img
                  src={imgPromotion}
                  height={146}
                  width={248}
                  style={{
                    position: "absolute",
                    marginTop: "84%",
                    marginLeft: "4%",
                    borderRadius: "20px",
                  }}
                />
                <img
                  src={
                    userProfile.company === "ICPF"
                      ? image.appPreviewFer
                      : userProfile.company === "ICPI"
                        ? image.appPreviewInter
                        : image.appPreviewLadda
                  }
                  height={600}
                  width={266}
                  style={{ borderRadius: "20px" }}
                />
              </div>
            </Col>
            <Col span={12}>
              <div
                style={{
                  borderColor: color.Disable,
                  border: "solid",
                  borderRadius: "22px",
                }}
              >
                <img
                  src={imgPromotion}
                  height={134}
                  width={246}
                  style={{
                    position: "absolute",
                    marginTop: "25%",
                    marginLeft: "4%",
                    borderRadius: "12px",
                  }}
                />
                <Row
                  style={{
                    position: "absolute",
                    marginTop: "75%",
                    marginLeft: "4%",
                    width: "90%",
                  }}
                >
                  <Col span={24}>
                    {form.getFieldValue("promotionSubject") ? (
                      <Text fontWeight={700}>{form.getFieldValue("promotionSubject")}</Text>
                    ) : (
                      <Text fontWeight={700}>(ชื่อโปรโมชัน)</Text>
                    )}
                  </Col>
                  <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
                  {form.getFieldValue("promotionDetail") && (
                    <>
                      <Col span={24}>
                        <Text level={6}>รายละเอียดโปรโมชัน</Text>
                      </Col>
                      <Col span={24}>
                        <Text level={6}>{form.getFieldValue("promotionDetail")}</Text>
                      </Col>
                    </>
                  )}
                  <img src={image.detailPromotionCard} height={180} width={245} className='pt-3' />
                </Row>
                <img src={image.detailPromotion} height={600} width={268} />
              </div>
            </Col>
          </Row>
        </Modal>
      )}
      {isDone && (
        <Modal open={isDone} footer={null} width={220} closable={false}>
          <FlexCol align='center' justify='center' style={{ width: 172, height: 172 }}>
            <CheckCircleTwoTone twoToneColor={color.success} style={{ fontSize: 36 }} />
            <br />
            <Text level={4} align='center'>
              บันทึกสำเร็จ
            </Text>
          </FlexCol>
        </Modal>
      )}
    </>
  );
};

const DetailOrderTab: React.FC = () => {
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const companyCode = JSON.parse(localStorage.getItem("company")!);

  const { company } = userProfile;
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const promotionType = useRecoilValue(promotionState)?.promotion?.promotionType;
  const [filter, setFilter] = useState({
    search: "",
    sortDirections: "ASC",
    sortFields: "createAt",
    page: 1,
    startDate: "",
    endDate: "",
    zone: "",
  });
  const [data, setData] = useState<{ count: number; data: any }>();
  const [zone, setZone] = useState<{ label: string; value: string; key: string }[]>([]);

  const getPromotionOrder = async () => {
    await getPromotionOrderDetailReport({
      company: companyCode.companyCode,
      promotionId: pathSplit[4],
      page: filter.page,
      take: 10,
      startDate: filter.startDate,
      endDate: filter.endDate,
      zone: filter.zone,
      searchText: filter.search,
      sortField: filter.sortFields,
      sortDirection: filter.sortDirections,
    }).then((res) => {
      setData(res);
    });
  };
  const getZoneByCompany = async () => {
    const res = await zoneDatasource.getAllZoneByCompany(company);
    const data = res.map((item: any) => {
      return {
        label: item.zoneName,
        value: item.zoneName,
        key: item.zoneId,
      };
    });
    setZone(data);
  };
  const downloadOrderExcel = async (search: string, startDate: string, endDate: string) => {
    getExcelOrderProReport(companyCode.companyCode, pathSplit[4], search, 1, startDate, endDate)
      .then((res) => {
        const blob = new Blob([res], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const a = document.createElement("a");
        a.href = window.URL.createObjectURL(blob);
        a.download = `Promotion Report_Order_lists${
          startDate ? moment(startDate).format("YYYY-MM-DD") : ""
        } - ${endDate ? moment(endDate).format("YYYY-MM-DD") : ""}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getPromotionOrder();
    getZoneByCompany();
  }, [filter]);

  const columns = [
    {
      title: (
        <Row justify={"space-between"} gutter={8}>
          <Col>
            <Text fontWeight={600} fontSize={16}>
              รหัสคำสั่งซื้อ
            </Text>
          </Col>
          <Col>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                cursor: "pointer",
              }}
            >
              <CaretUpOutlined
                style={{
                  position: "relative",
                  top: 2,
                }}
                onClick={() =>
                  setFilter({
                    ...filter,
                    page: 1,
                    sortFields: "createAt",
                    sortDirections: "ASC",
                  })
                }
              />
              <CaretDownOutlined
                style={{
                  position: "relative",
                  bottom: 2,
                }}
                onClick={() =>
                  setFilter({
                    ...filter,
                    page: 1,
                    sortFields: "createAt",
                    sortDirections: "DESC",
                  })
                }
              />
            </div>
          </Col>
        </Row>
      ),
      dataIndex: "createAt",
      render: (value: string, row: any) => (
        <>
          <Text level={6}>{row.orderNo}</Text>
          <br />
          <Text level={6} color='Text3'>
            {moment(row.createAt).format("DD/MM/YYYY HH:mm น.")}
          </Text>
        </>
      ),
    },
    {
      title: (
        <Row justify={"space-between"} gutter={8}>
          <Col>
            <Text fontWeight={600} fontSize={16}>
              ชื่อร้านค้า
            </Text>
          </Col>
        </Row>
      ),
      dataIndex: "customerName",
      render: (value: string, row: any) => {
        return (
          <>
            <Text level={6}>{row.customerName}</Text>
            <br />
            <Text level={6} color='Text3'>
              {row.customerZone}
            </Text>
          </>
        );
      },
    },
    {
      title: (
        <Row justify={"space-between"} gutter={8}>
          <Col>
            <Text fontWeight={600} fontSize={16}>
              ยอดขายที่ใช้โปร (บาท)
            </Text>
          </Col>
          <Col>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                cursor: "pointer",
              }}
            >
              <CaretUpOutlined
                style={{
                  position: "relative",
                  top: 2,
                }}
                onClick={() =>
                  setFilter({
                    ...filter,
                    page: 1,
                    sortFields: "totalPrice",
                    sortDirections: "ASC",
                  })
                }
              />
              <CaretDownOutlined
                style={{
                  position: "relative",
                  bottom: 2,
                }}
                onClick={() =>
                  setFilter({
                    ...filter,
                    page: 1,
                    sortFields: "totalPrice",
                    sortDirections: "DESC",
                  })
                }
              />
            </div>
          </Col>
        </Row>
      ),
      dataIndex: "totalPrice",
      render: (value: number, row: any) => {
        return (
          <>
            <Text level={6}>{value > 0 ? numberFormatter(value, 2) : "-"}</Text>
          </>
        );
      },
    },
    {
      title: (
        <Row justify={"space-between"} gutter={8}>
          <Col>
            <Text fontWeight={600} fontSize={16}>
              {promotionType?.includes("FREEBIES")
                ? "ยอดของแถมที่ใช้ (บาท)"
                : "ยอดส่วนลดที่ใช้ (บาท)"}
            </Text>
          </Col>
          <Col>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                cursor: "pointer",
              }}
            >
              <CaretUpOutlined
                style={{
                  position: "relative",
                  top: 2,
                }}
                onClick={() =>
                  setFilter({
                    ...filter,
                    page: 1,
                    sortFields: promotionType?.includes("FREEBIES")
                      ? "totalFreebiesDiscount"
                      : "totalDiscount",
                    sortDirections: "ASC",
                  })
                }
              />
              <CaretDownOutlined
                style={{
                  position: "relative",
                  bottom: 2,
                }}
                onClick={() =>
                  setFilter({
                    ...filter,
                    page: 1,
                    sortFields: promotionType?.includes("FREEBIES")
                      ? "totalFreebiesDiscount"
                      : "totalDiscount",
                    sortDirections: "DESC",
                  })
                }
              />
            </div>
          </Col>
        </Row>
      ),
      dataIndex: promotionType?.includes("FREEBIES") ? "totalFreebiesDiscount" : "totalDiscount",
      hidden: promotionType?.includes("OTHER"),
      render: (value: number, row: any) => {
        return (
          <>
            <Text level={6}>{value > 0 ? numberFormatter(value, 2) : "-"}</Text>
          </>
        );
      },
    },
  ].filter((x) => !x.hidden);

  return (
    <>
      <Row gutter={8} justify={"space-around"}>
        <Col span={7} style={{ paddingTop: "15px", paddingLeft: "15px" }}>
          <Text level={5}>คำสั่งซื้อทั้งหมด : {data?.count} รายการ</Text>
        </Col>
        <Col span={5}>
          <Input
            value={filter.search}
            onChange={(e) =>
              setFilter({
                ...filter,
                search: e.target.value,
              })
            }
            placeholder='ค้นหารหัสคำสั่งซื้อ/ชื่อร้านค้า'
            suffix={<SearchOutlined />}
          />
        </Col>
        <Col span={5}>
          <Select
            //value={filter.zone}
            allowClear
            placeholder='เขตทั้งหมด'
            onChange={(val) =>
              setFilter({
                ...filter,
                zone: val,
              })
            }
            data={zone || []}
            style={{ width: "100%" }}
          />
        </Col>
        <Col span={4}>
          <RangePicker
            style={{
              marginLeft: "10px",
              width: "100%",
            }}
            enablePast
            allowEmpty={[true, true]}
            value={!filter.startDate ? undefined : [dayjs(filter.startDate), dayjs(filter.endDate)]}
            onChange={(date) => {
              if (date) {
                setFilter({
                  ...filter,
                  startDate: moment(date[0]?.$d).format(),
                  endDate: moment(date[1]?.$d).format(),
                });
              } else {
                setFilter({
                  ...filter,
                  startDate: "",
                  endDate: "",
                });
              }
            }}
          />
        </Col>
        <Col span={3}>
          <Buttons
            style={{
              width: "140px",
              marginLeft: "20px",
            }}
            title='ดาวน์โหลด'
            icon={<DownloadOutlined style={{ fontSize: "18px" }} />}
            onClick={() => downloadOrderExcel(filter.search, filter.startDate, filter.endDate)}
          />
        </Col>
      </Row>
      <br />
      <br />
      <Table
        columns={columns}
        dataSource={data?.data}
        scroll={{ y: 500 }}
        pagination={{
          pageSize: 10,
          current: filter.page,
          total: data?.count,
          showSizeChanger: false,
          position: ["bottomCenter"],
          onChange: (page) => {
            setFilter({
              ...filter,
              page,
            });
          },
        }}
        size='large'
      />
    </>
  );
};

const HistoryTab: React.FC = () => {
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const [loading, setLoading] = useState(false);
  const [histories, setHistories] = useState<PromotionSettingHistory[]>();

  useEffect(() => {
    if (!loading) fetchHistory();
  }, []);

  const fetchHistory = async () => {
    setLoading(true);
    const id = pathSplit[4];
    await getPromotionLog(id)
      .then((res) => {
        setHistories(res?.map((h: any, i: number) => ({ ...h, key: i })));
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const columns = [
    {
      title: "วันเวลาที่อัปเดต",
      dataIndex: "createdAt",
      align: "center" as AlignType,
      render: (createdAt: string) => moment(createdAt).format("DD/MM/YYYY HH:mm น."),
    },
    {
      title: "กิจกรรม",
      dataIndex: "action",
      align: "center" as AlignType,
      render: (action: string) => {
        const mapValue: any = {
          CreatePromotion: "สร้างโปรโมชัน",
          Changedata: "แก้ไขโปรโมชัน",
          Changestatus: "อนุมัติโปรโมชัน",
        };
        const value = action?.replaceAll(" ", "");
        return <Text level={6}>{mapValue[value]}</Text>;
      },
    },
    {
      title: "ก่อนแก้ไข",
      dataIndex: "beforeValue",
      align: "center" as AlignType,
      render: (value: string, row: any) => {
        const action = row.action?.replaceAll(" ", "");
        return (
          <>
            {action === "Changestatus" ? (
              <Tag color={value === "true" ? color.success : color.warning}>
                {value === "true" ? "อนุมัติแล้ว" : "รอการตรวจสอบ"}
              </Tag>
            ) : (
              <Text level={6}>{value || "-"}</Text>
            )}
          </>
        );
      },
    },
    {
      title: "หลังแก้ไข",
      dataIndex: "afterValue",
      align: "center" as AlignType,
      render: (value: string, row: any) => {
        const action = row.action?.replaceAll(" ", "");
        return (
          <>
            {action === "CreatePromotion" ? (
              <Tag color={color.warning}>รอการตรวจสอบ</Tag>
            ) : action === "Changestatus" ? (
              <Tag color={value === "true" ? color.success : color.warning}>
                {value === "true" ? "อนุมัติแล้ว" : "รอการตรวจสอบ"}
              </Tag>
            ) : (
              <Text level={6}>{value || "-"}</Text>
            )}
          </>
        );
      },
    },
    {
      title: "ผู้ใช้งาน",
      dataIndex: "createBy",
      align: "center" as AlignType,
      render: (createBy: string) => createBy || "-",
    },
  ];

  return (
    <>
      <br />
      <Text fontWeight={700}>รายการประวัติการสร้างโปรโมชัน</Text>
      <br />
      <br />
      <TableContainer>
        <Table
          columns={columns}
          dataSource={histories}
          pagination={false}
          style={{ height: "500px" }}
          scroll={{ y: 500 }}
        />
      </TableContainer>
    </>
  );
};
